var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-scrollbar",class:{'has-footer': _vm.footerVisible},attrs:{"id":"app"}},[_c('v-dialog',{attrs:{"width":"80%"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.footerVisible)?_c('Footer',{staticClass:"app-footer"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-574d636e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = XZaA
// module chunks = 29